export default "__VITE_ASSET__BkoQ6w1$__"